<!-- Responsibility: Implement scene history sidebar behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<scene-history-sidebar>
  <aside class="history-sidebar" onclick={ onSidebarClick }>
    <header>
      <strong>FIELD LOG</strong>
      <button type="button" aria-label="Close field log" data-action="close">✕</button>
    </header>
    <div>
      <section data-block="player">
        <button
          type="button"
          data-e2e-open="player-profile"
          aria-label="Open player profile"
          data-action="profile"
          onkeydown={ (e) => props.actions?.onActivateKey?.(e, props.actions?.openPlayerModal) }
        >
          <span style="background-image:{ props.view?.portraitUrl ? 'url('+props.view.portraitUrl+')' : 'none' }">
            <span if={ !props.view?.portraitUrl }>{ (props.view?.playerName || '?').slice(0, 2).toUpperCase() }</span>
          </span>
          <span>
            <strong>{ props.view?.playerName || 'UNKNOWN' }</strong>
            <span>tap for full profile</span>
          </span>
        </button>
      </section>

      <section data-block="companions" if={ props.view?.companions?.length }>
        <button
          each={ companion in props.view.companions }
          type="button"
          data-e2e-open="companion"
          data-tip={ companion.name }
          data-action="companion"
          data-companion={ companion.name }
        >
          <img if={ companion.portraitUrl } src={ companion.portraitUrl } alt={ companion.name }>
          <span if={ !companion.portraitUrl }>{ companion.name[0].toUpperCase() }</span>
        </button>
      </section>

      <section data-block="vitals" if={ props.view?.playerVitals }>
        <button type="button" data-kind="vitality" aria-label={ `Vitality ${vitalText('vitality')}` } data-action="vital">❤ { vitalText('vitality') }</button>
        <button type="button" data-kind="spirit" aria-label={ `Spirit ${vitalText('spirit')}` } data-action="vital">✦ { vitalText('spirit') }</button>
        <button type="button" data-kind="essence" aria-label={ `Essence ${vitalText('essence')}` } data-action="vital">✿ { vitalText('essence') }</button>
      </section>

      <section data-block="effects" if={ props.view?.playerEffectChips?.length || props.view?.playerDormantEffectChips?.length }>
        <span each={ fx in props.view.playerEffectChips } role="status">{ fx }</span>
        <span each={ fx in props.view.playerDormantEffectChips } data-state="dormant" role="note">{ fx }</span>
      </section>

      <section data-block="world-log" if={ props.view?.worldLog?.length }>
        <header>
          <strong>WORLD LOG</strong>
          <button type="button" data-action="worldLog">Open log</button>
        </header>
        <button
          type="button"
          data-kind={ props.view.worldLog[0].type }
          data-action="worldEntry"
        >
          <time>{ props.view.worldLog[0].time }</time>
          <span>{ props.view.worldLog[0].text }</span>
        </button>
      </section>

      <h3>History</h3>
      <journal-feed historyOnly={ true } excludeTailCount={ props.view?.excludeTailCount || 0 }></journal-feed>
    </div>
  </aside>

  <script>
    import JournalFeed from './journal-feed.riot'
    import { formatVitalValue } from '../../engine/vitals'

    export default {
      components: { JournalFeed },

      vitalText(key) {
        return formatVitalValue(this.props.view?.playerVitals ?? {}, key)
      },

      onSidebarClick(e) {
        const btn = e.target.closest('button[data-action]')
        if (!btn) return
        const action = btn.dataset.action
        const acts = this.props.actions || {}

        if (action === 'close') acts.closeHistory?.()
        if (action === 'profile') acts.openPlayerModal?.()
        if (action === 'companion') {
          const name = btn.dataset.companion
          const comp = this.props.view?.companions?.find(c => c.name === name)
          if (comp) acts.openCompanionModal?.(comp)
        }
        if (action === 'vital') acts.openVitalModal?.(btn.dataset.kind)
        if (action === 'worldLog') acts.openWorldLogModal?.()
        if (action === 'worldEntry') acts.openWorldLogEntry?.(this.props.view?.worldLog?.[0])
      }
    }
  </script>
</scene-history-sidebar>